// The Client features (client column, client picker) only apply when working
// inside the JLL Master Tenant — surveys there are created on behalf of clients.
export function isMasterTenant(currentTenant) {
  return (
    (currentTenant?.tenantCode || '').toUpperCase() === 'JLL' ||
    /jll\s*master/i.test(currentTenant?.tenantName || '')
  );
}
